/**
 * @file useHover
 * @author sunwen05
 */

import {useEffect, useCallback} from 'react';

import useBoolean from '../boolean';

export default (elementRef: React.MutableRefObject<any>): boolean => {
    const [hovered, on, off] = useBoolean(false);

    const onMouseEnter = useCallback(() => on(), [on]);
    const onMouseLeave = useCallback(() => off(), [off]);

    useEffect(() => {
        if (elementRef.current) {
            elementRef.current.onmouseenter = onMouseEnter;
            elementRef.current.onmouseleave = onMouseLeave;
        }
    }, [elementRef, onMouseEnter, onMouseLeave]);

    return hovered;
};
